import { useTranslation } from 'react-i18next';

import { IconButtonProps } from '@mui/material';
import { styled } from '@mui/material/styles';

import { Cross } from '@/components/icons/Cross';
import { IconTooltipButton } from '@/components/iconTooltipButton/IconTooltipButton';

type TGenericModalCloseProps = Omit<IconButtonProps, 'onClick' | 'children' | 'aria-label'> & {
  onClick: IconButtonProps['onClick'];
};

const StyledClose = styled(IconTooltipButton, { name: 'GenericModalClose' })({
  position: 'absolute',
  top: 16,
  right: 16,
  zIndex: 1,
});

/**
 * Close (X) button pinned to the top-right corner of a modal.
 *
 * What: icon button whose tooltip and screen-reader name are both `common.close`.
 * Constraints: stays absolutely positioned inside the modal. When `disabled` (for example while
 * a form submits), IconTooltipButton wraps the button in a zero-size span, so the position is
 * unchanged. Callers pass only `onClick` (and optionally `disabled`).
 */
export const GenericModalClose = (props: TGenericModalCloseProps) => {
  const { t } = useTranslation();

  return (
    <StyledClose label={t('common.close')} {...props}>
      <Cross />
    </StyledClose>
  );
};
